import signUp from "utils/signup/signup"

function onBack(cb) {
  return function historyListener() {
    cb()
    window.removeEventListener("popstate", historyListener)
  }
}

export default function setListeners() {
  const { is_app: isApp } = window.FCGON

  // Handling clicks on sign up links and buttons
  const config = [
    { qs: ".js-sign-up-two-steps" },
    { qs: ".js-sign-up-two-steps-no-free", freeOfferAvailable: false },
  ]

  config.forEach((obj) => {
    const nodes = document.querySelectorAll(obj.qs)

    ;[...nodes].forEach((node) => {
      node.addEventListener("click", (e) => {
        e.preventDefault()

        if (isApp) {
          const { callNativeApp } = window
          if (callNativeApp) {
            callNativeApp("subscribe")
            return
          }
        }

        signUp(obj).then((vm) => {
          window.history.pushState({ reason: "signup" }, "forecast_page", window.location.href)
          const popStateListener = onBack(() =>
            vm.$el.parentNode ? vm.destroy({ reason: "history_change" }) : null,
          )
          vm.$on("destroy", ({ reason }) => {
            window.removeEventListener("popstate", popStateListener)
            if (reason !== "history_change") window.history.back()
          })
          window.addEventListener("popstate", popStateListener)
        })
      })
    })
  })

  // const { FCGON } = window;

  // // Automatic startup on the dedicated sign up page
  // if (FCGON && FCGON.sign_up_immediately) {
  //   signUp({
  //     freeOfferAvailable: FCGON.sign_up_free_offer_available,
  //     runningInsideApp: FCGON.running_inside_app,
  //     firstTab: FCGON.first_tab ? FCGON.first_tab : 'default',
  //   });
  // }
}
